import store from '@/store';
import authentication from '@/authentication';
import user from '@/components/user';
import constants from '@/constants';
import Home from './Home.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter(to, from, next) {
      const currentUser = store.state[user.store.namespace].currentUser;
      if ('approved' in currentUser && currentUser.approved) {
        // If we're approved, we're logged in and can see the site
        next();
      } else if (store.state[authentication.store.namespace].isLoggedIn) {
        // If we're just logged in, we can see our settings
        next({ name: 'Settings' });
      } else {
        next({ name: 'Login' });
      }
    },
  },
];

export default routes;
